import _Map from "@babel/runtime-corejs3/core-js/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import moment from "moment";
import { normalize } from "normalizr";
import { clientActivitiesSchema } from "./dashboard-squema";
import { SET_MORTGAGES, SET_ACTIVITIES, SET_BIRTHDAYS, SET_CLIENT_ACTIVITY, SET_YOY_SUBMITTED, SET_CLOSES, SET_COMPLETED_APPS, SET_IN_PROGRESS_APPS, SET_D2L_SUBMISSIONS, RESET_CLIENT_ACTIVITY } from "./dashboard-mutations";
import { getNearApps, getNearFollowups, getNearBirthdays, getClientActivity, getSubmissionHistoryByAgent, getAppsReceivedByYear, getClosesByMonth, getApplicationsByUser } from "../api/dashboard-api";
import { CLIENT_APPLICATION_STATUS } from "../../../../../shared/js/enum";
import Err from "@Broker/@Routes/error";
const responseCache = new _Map();
export const clearDashboardCache = () => {
  responseCache.clear();
};
const cachedApiCall = async (cacheKey, expiryTime, apiCallFn) => {
  const now = Date.now();
  const cachedData = responseCache.get(cacheKey);
  if (cachedData && now - cachedData.timestamp < expiryTime) {
    return cachedData.data;
  }
  const result = await apiCallFn();
  responseCache.set(cacheKey, {
    data: result,
    timestamp: now
  });
  return result;
};
export const LOAD_MORTGAGES = "LOAD_MORTGAGES";
export const LOAD_ACTIVITIES = "LOAD_ACTIVITIES";
export const LOAD_BIRTHDAYS = "LOAD_BIRTHDAYS";
export const LOAD_CLIENT_ACTIVITY = "LOAD_CLIENT_ACTIVITY";
export const LOAD_D2L_SUBMISSIONS = "LOAD_D2L_SUBMISSIONS";
export const LOAD_YOY_SUBMITTED = "LOAD_YOY_SUBMITTED";
export const LOAD_CLOSES = "LOAD_CLOSES";
export const LOAD_APPLICATIONS = "LOAD_APPLICATIONS";
export const LOAD_COMPLETED_APPS = "LOAD_COMPLETED_APPS";
export const LOAD_IN_PROGRESS_APPS = "LOAD_IN_PROGRESS_APPS";
const actions = {
  [LOAD_MORTGAGES]: async (context, {
    days,
    agentUsername,
    completed
  }) => {
    var _context$rootState$Ac, _context$rootState$Ac2;
    const status = completed ? CLIENT_APPLICATION_STATUS.completed : null;
    const includeExisting = (_context$rootState$Ac = (_context$rootState$Ac2 = context.rootState.AccountStore.accountPreferences) == null ? void 0 : _context$rootState$Ac2.includeExisting) != null ? _context$rootState$Ac : false;
    const cacheKey = `mortgages_${days}_${agentUsername}_${status}_${includeExisting}`;
    const result = await cachedApiCall(cacheKey, 60 * 60 * 1000, () => getNearApps(days, agentUsername, status));
    context.commit(SET_MORTGAGES, {
      clients: result.mortgageRenewalsGrouped,
      days,
      agentUsername,
      status
    });
  },
  [LOAD_ACTIVITIES]: async (context, {
    days,
    expired
  }) => {
    const cacheKey = `activities_${days}_${expired}`;
    const result = await cachedApiCall(cacheKey, 60 * 60 * 1000, () => getNearFollowups(days, expired));
    context.commit(SET_ACTIVITIES, {
      clients: result,
      days,
      expired
    });
  },
  [LOAD_BIRTHDAYS]: async (context, {
    days,
    agentUsername
  }) => {
    const cacheKey = `birthdays_${days}_${agentUsername}`;
    const result = await cachedApiCall(cacheKey, 60 * 60 * 1000, () => getNearBirthdays(days, agentUsername));
    context.commit(SET_BIRTHDAYS, {
      clients: result,
      days,
      agentUsername
    });
  },
  [LOAD_CLIENT_ACTIVITY]: async (context, {
    agentUsername,
    offset,
    limit,
    loadAll
  }) => {
    try {
      var _clientActivity$;
      const clientActivity = await getClientActivity(agentUsername, loadAll, {
        offset,
        limit
      });
      const {
        entities,
        result
      } = normalize(clientActivity, [clientActivitiesSchema]);
      if (offset === 0) context.commit(RESET_CLIENT_ACTIVITY);
      context.commit(SET_CLIENT_ACTIVITY, {
        clients: {
          byId: entities.clientActivities || {},
          allIds: result
        }
      });
      const totalRecords = _parseInt((_clientActivity$ = clientActivity[0]) == null ? void 0 : _clientActivity$.total) || 0;
      const count = context.state.clientActivity.allIds.length;
      return count < totalRecords;
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_D2L_SUBMISSIONS]: async (context, {
    agentUsername,
    loadAll
  }) => {
    const result = await getSubmissionHistoryByAgent(agentUsername, loadAll);
    context.commit(SET_D2L_SUBMISSIONS, {
      submissions: result.submissionHistory
    });
  },
  [LOAD_YOY_SUBMITTED]: async (context, {
    agentUsername
  }) => {
    const result = await getAppsReceivedByYear(agentUsername);
    context.commit(SET_YOY_SUBMITTED, {
      applications: result.report
    });
  },
  [LOAD_CLOSES]: async (context, {
    agentUsername,
    month
  }) => {
    const currentMonth = await getClosesByMonth(month, agentUsername);
    const previousDate = moment(month).subtract(1, "months").format("YYYY-MM-01");
    const previousMonth = await getClosesByMonth(previousDate, agentUsername);
    context.commit(SET_CLOSES, {
      currentMonth,
      previousMonth
    });
  },
  [LOAD_APPLICATIONS]: async (context, {
    agentUsername
  }) => {
    const result = await getApplicationsByUser(agentUsername);
    context.commit(SET_COMPLETED_APPS, {
      applications: result.completedChart
    });
    context.commit(SET_IN_PROGRESS_APPS, {
      applications: result.inProgressChart
    });
  },
  [LOAD_COMPLETED_APPS]: async (context, {
    agentUsername
  }) => {
    const result = await getApplicationsByUser(agentUsername);
    context.commit(SET_COMPLETED_APPS, {
      applications: result.completedChart
    });
  },
  [LOAD_IN_PROGRESS_APPS]: async (context, {
    agentUsername
  }) => {
    const result = await getApplicationsByUser(agentUsername);
    context.commit(SET_IN_PROGRESS_APPS, {
      applications: result.inProgressChart
    });
  }
};
export default actions;